export const SUBMIT_TRANSACTION_TIMEOUT = 60 * 10000

/**
 * Reviewable request states.
 *
 * @enum {string}
 */
export const reviewableRequestStates = Object.freeze({
  approved: 'approved',
  rejected: 'rejected',
  permanentlyRejected: 'permanently_rejected'
})

/**
 * Lot states.
 *
 * @enum {string}
 */
export const lotStates = Object.freeze({
  pending: 'pending',
  sold: 'sold',
  finished: 'finished'
})

/**
 * Lot types.
 *
 * @enum {string}
 */
export const lotTypes = Object.freeze({
  noAuction: 'no_auction',
  englishAuction: 'eng',
  copartAuction: 'copart',
  iaaiAuction: 'iaai'
})

/**
 * Account types.
 *
 * @enum {number}
 */
export const accountTypes = Object.freeze({
  master: 1,
  platform: 2,
  dealer: 3,
  user: 4,
  admin: 5
})

/**
 * Participant states.
 *
 * @enum {string}
 */
export const participantStates = Object.freeze({
  depositPending: 'deposit_pending',
  pending: 'pending',
  rejected: 'rejected',
  winner: 'winner',
  buyNowWinner: 'buy_now_winner'
})

/**
 * Deposit states.
 *
 * @enum {string}
 */
export const depositStates = Object.freeze({
  pending: 'pending',
  paid: 'paid',
  returned: 'returned'
})
